module.exports = __webpack_public_path__ + "img/zoujinketang.603a9e0e.png";